import { render, staticRenderFns } from "./issue_row.vue?vue&type=template&id=1e5bfdf4&scoped=true&lang=pug"
import script from "./issue_row.vue?vue&type=script&lang=js"
export * from "./issue_row.vue?vue&type=script&lang=js"
import style0 from "./issue_row.vue?vue&type=style&index=0&id=1e5bfdf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5bfdf4",
  null
  
)

export default component.exports